export default "__VITE_ASSET__ew7rY$bK__"